import React, { useContext } from 'react';
import PageContent from '../components/PageContent';
import Congratulations from '../components/Congratulations';

import CompanyContacts from '../components/CompanyContacts';
import CongratulationEmail from '../components/CongratulationEmail';
import ConfirmLeaveModal from '../components/ConfirmLeaveModal';
import { AppContext } from '../context';

const Final = ({ history }) => {
  const { userData, proposal, clearContext } = useContext(AppContext);

  return (
    <>
      <PageContent>
        <Congratulations orderNum={proposal.identificacao.codigoNegocio} />
        <CongratulationEmail
          email={userData.pessoa.comunicacao.parametros[0].valor}
        />
        <CompanyContacts />
        <ConfirmLeaveModal
          title="A sua compra já foi concluída"
          acceptLabel="Quero voltar"
          navigate={() => {
            history.push('/objetivo');
          }}
          onAccept={() => clearContext()}
        >
          <p>Deseja voltar ao início e fazer um novo plano?</p>
        </ConfirmLeaveModal>
      </PageContent>
    </>
  );
};

export default Final;
